import React from "react";
import BrandLogo from "./BrandLogo";
import Filter from "./Filter";
import NavBarButtonList from "./NavBarButtonList";

export default function Navbar() {
  return (
    <>
      <nav className="py-4 2xl:px-6">
        <div className="container flex items-center justify-between">
          <BrandLogo />
          <NavBarButtonList />
          <Filter />
        </div>
      </nav>
    </>
  );
}
